export default __webpack_public_path__ + "static/media/70.ce2b08ec.png";